// ======================================================================
// File Name       : ContentSearchForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import { Form, Col, Button } from 'react-bootstrap';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { CONTENT_TYPE } from '../../constants/ContentConstant';
import * as Path from '../../constants/PathConstants';
import CustomButton from '../button/CustomButton';

class ContentLinkContentSearchForm extends React.Component {
  render() {
    const props = this.props;
    return (
      <Form onSubmit={props.handleSubmit} className="form-horizontal">
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            コンテンツ種別
          </Col>
          <Col sm={9} className='padding-right-15'>
            <Field
              name="contentType"
              component="select"
              className="form-select"
              parse={(value) => (value ? parseInt(value, 10) : "")}
            >
              {SELECT_BOX_DATA.CONTENT_TYPE_NOT_QUESTION.map(
                (contentTypeInfo, index) => {
                  const { name, value } = contentTypeInfo;
                  if (!name) {
                    return <option key={index} />;
                  }

                  return (
                    <option key={index} value={value}>
                      {name}
                    </option>
                  );
                },
              )}
            </Field>
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            コンテンツ識別ID
          </Col>
          <Col sm={9} className='padding-right-15'>
            <Field
              name="contentSecernId"
              component="input"
              type="text"
              className="form-control"
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            コンテンツ名
          </Col>
          <Col sm={9} className='padding-right-15'>
            <Field
              name="contentName"
              component="input"
              type="text"
              className="form-control"
            />
          </Col>
        </Form.Group>
        {props.showRemarkField && (
          <Form.Group className="form-info">
            <Col sm={3} as={Form.Label}>
              備考
            </Col>
            <Col sm={9} className='padding-right-15'>
              <Field
                name="remark"
                component="input"
                type="text"
                className="form-control"
              />
            </Col>
          </Form.Group>
        )}
        <Form.Group className="margin-top-20 text-center">
          <Col sm={12}>
            {/* <Button bsStyle="primary" className="btn-96" type="submit">
              
            </Button> */}
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              type="submit"
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
        </Form.Group>
      </Form>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('contentLinkContentSearchForm');
const mapStateToProps = (state) => {
  const contentType = selector(state, 'contentType');
  const showRemarkField = contentType == CONTENT_TYPE.LINK;
  const { parentPath, searchCondition } = state.page;
  let initialValues = {};
  if (parentPath === Path.COURSE_LIST) initialValues = searchCondition;
  return {
    showRemarkField,
    formValues: getFormValues('contentLinkContentSearchForm')(state),
    initialValues,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'contentLinkContentSearchForm',
    touchOnChange: true,
  })(ContentLinkContentSearchForm),
);
